export default __webpack_public_path__ + "static/image_evenement@2x-a9cd76e15c1adf5cf8dc7c873735db12.jpg";